export default "__VITE_ASSET___nOJZK39__"